export default __webpack_public_path__ + "static/media/infra-8.1675e0d8.webp";